var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#E1EDFF",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D42CF",
    d: "M21.719 10.281q.28.313.281.719 0 .405-.281.719l-8 8A1.04 1.04 0 0 1 13 20q-.405 0-.719-.281l-4-4A1.04 1.04 0 0 1 8 15q0-.405.281-.719.313-.28.719-.281.405 0 .719.281l3.25 3.313 7.312-7.313q.313-.28.719-.281.405 0 .719.281"
  })));
};
export default SvgCheckMark;